var DatePicker = require('modules/date-picker');
var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

function getMonthName(date) {
	var monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
	return monthNames[date.getMonth()];
}

function formatDate(date) {
	return getMonthName(date) + ' ' + date.getDate() + ', ' + date.getFullYear();
}

function EventFilter(el) {
	this.el = el;
	this.toggle = this.el.querySelector('.js-calendar-toggle');
	this.event = Array.prototype.slice.call(this.el.querySelectorAll('[data-date-start]'));
	this.selectedDate = this.el.querySelector('.js-selected-date');
	this.dateLabel = this.el.querySelector('.js-today-date');
	this.currentPage = 0;

	this.calendarTrigger();
	// this.clickOutside();
}

EventFilter.prototype.calendarTrigger = function() {
	var t = this;
	if ( t.toggle ) {
		t.calendarToggle();
	}
};

EventFilter.prototype.calendarToggle = function() {
	var t = this;

	t.calendar = new DatePicker(t.selectedDate, {
		format: function(selectedDate) {
			return formatDate(selectedDate);
		}
	});

	t.selectedDate.addEventListener('change', function() {
		var date = new Date(t.selectedDate.value),
			month = date.getUTCMonth() + 1,
			day = date.getDate();

		if (day < 10) {
			day = '0' + day;
		}

		if (month < 10) {
			month = '0' + month;
		}
		var returnDate = month + '/' + day + '/' + date.getFullYear();
		location.href = '?date=' + returnDate;
	});

	t.toggle.addEventListener('click', t.calendar.toggle.bind(t.calendar));
};

EventFilter.prototype.checkFilterDate = function() {
	var field = 'date',
		url = window.location.href;
	if( url.indexOf('?' + field + '=') !== -1 ) {
		return true;
	} else if( url.indexOf('&' + field + '=') !== -1 ) {
		return true;
	} else {
		return false;
	}
};

EventFilter.prototype.clickOutside = function() {
	var t = this;
	document.addEventListener('click', function (e) {
		if ( e.target !== t.toggle.parentNode.querySelector('.dp-below') && e.target != t.calendar ) {
			t.calendar.close();
			t.toggle.classList.remove('card-tabs__calendar--active');
		}
	});
};
module.exports = EventFilter;
